import plansModel from '../models/plans';
import plans from '../models/plans';
import projectsModel from '../models/projects';

const innerObject = {
  overTrialOrSubscription: () => (!plans.isActiveTrial() || plans.isOverSubscription()) && !plans.isPaidTeam(),
  noProjectMode: () => {
    const allProjects = projectsModel.getAllProjectsFast();

    return (!allProjects || allProjects.length === 0) && plansModel.isActiveAccount();
  },
};

export default innerObject;
